export const liveViewersV2 = (id: string) => `/meetings/livestreamSummary/${id}/viewers`;
export const liveQuestionsV2 = (id: string) => `/meetings/livestreamSummary/${id}/questions`;
export const meetingLiveStreamSummary = (meetingId: string, meetingName?: string) => `/meetings/livestreamByName/${encodeURIComponent(meetingName || meetingId)}/${meetingId}`;
export const MEETING_LIVE_STREAMS = '/meetings/livestreams';

export enum Actions {
  SET_NAME_FILTER = 'SET_NAME_FILTER',
}
